import { t } from "i18next";
import FTModal from "../../../components/common/FTModal";
import { TModalsState, setModalsData } from "../../../api/store/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  APP_CONFIG,
  REPORT_ADVANCE_FILTER_OPTIONS,
} from "../../../constants/constants";
import {
  AdminFormFieldDropdown,
  AdminFormFieldInput,
  AdminFormFieldSubmit,
} from "../../../components/admin/formFields";
import { useEffect, useState } from "react";
import svgIcons from "../../../assets/svg/svgIcons";
import { ReportTableColumn } from "../../../components/reports/reportTable";
import { getFieldSpecificFilterOptions } from "../util";
import { useLazyReportColumnFilterDropdownValuesQuery } from "../../../api/network/reportApiServices";
import { Label } from "recharts";
import PopupReportColumnFilter from "./popupReportColumnFilter";
import {
  REPORT_ADVANCED_FILTER_PARAM_NAME,
  REPORT_FIELD_OUTPUT_TYPES,
  REPORT_FILTER_OPERATOR_TYPES,
} from "../constants";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import { useCreateCustomReportContext } from "../context/createCustomReport.context";
import { TReportWithFields } from "../../../api/types/Report";
import ErrorBoundaryForSection from "../../../components/errorBoundaryForSection";

export type ApplyReportAdvancedFilterCallback = (
  identifier: string,
  value: string,
  filters: {
    identifier: string;
    fieldOutputType: REPORT_FIELD_OUTPUT_TYPES;
    selectedValues: string[];
    operator: string;
    id: string;
  }[]
) => void;

const FILTER_OPTIONS = [
  REPORT_ADVANCE_FILTER_OPTIONS.COLUMN,
  REPORT_ADVANCE_FILTER_OPTIONS.OPERATOR,
  REPORT_ADVANCE_FILTER_OPTIONS.VALUE,
];
type TFilterOption = {
  column: string;
  operator: string;
  value: string;
};
const initialState: TFilterOption[] = [
  {
    column: "",
    operator: "",
    value: "",
  },
];

type TAdvanceFilterPopUp = {
  columns: ReportTableColumn[];
  reportId: number;
  reportFilters: any;
  handleApplyReportAdvancedFilter: ApplyReportAdvancedFilterCallback;
};

const AdvanceFilterPopUp = ({
  columns,
  reportId,
  reportFilters,
  handleApplyReportAdvancedFilter,
}: TAdvanceFilterPopUp) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "reports.advance_filters",
  });
  const { t: tFilterOptions } = useTranslation("translation", {
    keyPrefix: "reports.columnFilters.filterOptions",
  });
  const dispatch = useDispatch();

  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );

  const hideModal = () => {
    dispatch(
      setModalsData({
        ...modalsState,
        showAdvanceFilterPopup: false,
      })
    );
  };

  const [formikInitialValues, setFormikInitialValues] = useState<any>({
    filterLogic: "1",
  });
  const { specificReportResponse } = useCreateCustomReportContext();
  const [initialReportAdvancedFilters, setInitialReportAdvancedFilters] =
    useState<TFilterOption[]>(initialState);
  useEffect(() => {
    if (specificReportResponse?.report_filters) {
      const advancedFilter = specificReportResponse?.report_filters?.find(
        (filter) => filter.param === REPORT_ADVANCED_FILTER_PARAM_NAME
      );
      if (!!advancedFilter) {
        const newRows =
          advancedFilter?.report_advance_filters?.map((filter) => ({
            column: filter.field,
            operator: filter.operator,
            value: filter.value,
          })) || initialState;
        setInitialReportAdvancedFilters(newRows);
        setRows(newRows);
        setSelectedColumns(
          newRows.map((row) =>
            columns.find((column) => column.all_field_id === row.column)
          )
        );
        setSelectedOperators(
          newRows.map(
            (row) => row.operator
            // REPORT_FILTER_OPERATOR_TYPES[
            //   row.operator as keyof typeof REPORT_FILTER_OPERATOR_TYPES
            // ]
          )
        );
        setSelectedValues(newRows.map((row) => row.value));
        setFormikInitialValues({
          filterLogic: advancedFilter?.value,
        });
      }
    } else {
      if (APP_CONFIG.DEBUG.ALL) console.log("specificReportResponse NO DATA");
    }
  }, [specificReportResponse]);

  const [rows, setRows] = useState<TFilterOption[]>(initialState);
  const [showExample, setShowExample] = useState(false);

  const columnsOptions = columns.slice(1).map((column) => ({
    value: column.id || "",
    label: column.header,
  }));
  const [showColumnsPopup, setShowColumnsPopup] = useState<boolean[]>([]);

  const [selectedColumns, setSelectedColumns] = useState<any[]>([]);
  const [selectedOperators, setSelectedOperators] = useState<any[]>([]);

  const [operatorOptions, setOperatorOptions] = useState<any[]>([]);
  const [selectedValues, setSelectedValues] = useState<any[]>([]);

  // validationSchema: Yup.object({
  //   filterLogic: Yup.string()
  //     // disabled as validating the filter logic is not working correctly
  //     // .matches(
  //     //   /^(\d+\s+(AND|OR)\s+\d+|\(\d+\s+(AND|OR)\s+\d+\)\s+(AND|OR)\s+)*(\d+\s+(AND|OR)\s+\d+|\(\d+\s+(AND|OR)\s+\d+\))$/,
  //     //   "Invalid filter logic format"
  //     // )
  //     .required("Filter logic is required"),
  // }),

  // Yup.string()
  //   .matches(
  //     new RegExp(
  //       `^(${Array.from({ length: rows.length }, (_, i) => i + 1).join("\\s+(AND|OR)\\s+")})$`
  //     ),
  //     "Invalid filter logic format"
  //   )
  //   .required("Filter logic is required"),

  // this is working to ensure all rows are included
  // ===============================================
  // Yup.string()
  //   .matches(
  //     new RegExp(
  //       `^\(${Array.from({ length: rows.length }, (_, i) => i + 1).join(
  //         "\\s+(AND|OR)\\s+"
  //       )})$`
  //     ),
  //     "Invalid filter logic format"
  //   )
  //   .required("Filter logic is required"),

  // this is working for brackets
  // ============================
  // Yup.string()
  //   .matches(
  //     new RegExp(
  //       `^\\(?\\d+(\\s+(AND|OR)\\s+\\(?\\d+\\)?)*\\)?(\\s+(AND|OR)\\s+\\(?\\d+(\\s+(AND|OR)\\s+\\(?\\d+\\)?)*\\)?)*$`
  //     ),
  //     "Invalid filter logic format"
  //   )
  //   .required("Filter logic is required"),

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: formikInitialValues,
    validationSchema: Yup.object({
      filterLogic:
        // filterLogic should be a required string and needs to have all row numbers in it, optionally allowing brackets
        Yup.string()
          .matches(
            new RegExp(
              `^\\(?\\d+(\\s+(AND|OR)\\s+\\(?\\d+\\)?)*\\)?(\\s+(AND|OR)\\s+\\(?\\d+(\\s+(AND|OR)\\s+\\(?\\d+\\)?)*\\)?)*$`
              // `^(\\(?\\d+(\\s+(AND|OR)\\s+\\(?\\d+\\)?)*\\)?(\\s+(AND|OR)\\s+\\(?\\d+\\)?)*\\)?$`
            ),
            "Invalid filter logic format"
          )
          .test(
            "all-rows-included",
            "All row numbers must be included",
            function (value) {
              const rowNumbers = Array.from({ length: rows.length }, (_, i) =>
                (i + 1).toString()
              );
              return rowNumbers.every((num) => value?.includes(num));
            }
          )
          .test(
            "no-extra-rows-to-be-included",
            "Extra row numbers are included",
            function (value) {
              const rowNumbers = Array.from({ length: rows.length }, (_, i) =>
                (i + 1).toString()
              );
              const allRowNumbersInValue = (value || "").match(/([0-9]+)/g);
              return allRowNumbersInValue?.every((num) =>
                rowNumbers.includes(num)
              );
            }
          )
          .required("Filter logic is required"),
    }),
    onSubmit: (values) => {
      if (selectedValues.some((value) => !!value)) {
        handleApplyReportAdvancedFilter(
          REPORT_ADVANCED_FILTER_PARAM_NAME,
          values.filterLogic,
          rows
            .filter((row, i) => selectedValues[i])
            .map((row, index) => ({
              identifier: selectedColumns[index]?.identifier,
              fieldOutputType: selectedColumns[index]?.field_output_type,
              id: selectedColumns[index]?.all_field_id,
              selectedValues: selectedValues[index],
              operator: selectedOperators[index],
            }))
        );
      }
      hideModal();
    },
  });
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isValid,
    setFieldValue,
    validateForm,
  } = formik;

  const addRow = () => {
    setRows([...rows, ...initialState]);
    setSelectedColumns([...selectedColumns, null]);
    setOperatorOptions([...operatorOptions, null]);
    setSelectedValues([...selectedValues, null]);
    setShowColumnsPopup([...showColumnsPopup, false]);
    setTimeout(() => {
      validateForm();
    }, 100);
  };

  const removeRow = (index: number) => {
    const indexToUpdate = index; // Replace with the desired index
    setRows((prev) => {
      return [
        ...prev.slice(0, indexToUpdate),
        ...prev.slice(indexToUpdate + 1),
      ];
    });
    setSelectedColumns((prev) => {
      return [
        ...prev.slice(0, indexToUpdate),
        ...prev.slice(indexToUpdate + 1),
      ];
    });
    setOperatorOptions((prev) => {
      return [
        ...prev.slice(0, indexToUpdate),
        ...prev.slice(indexToUpdate + 1),
      ];
    });
    setSelectedValues((prev) => {
      return [
        ...prev.slice(0, indexToUpdate),
        ...prev.slice(indexToUpdate + 1),
      ];
    });
    setShowColumnsPopup((prev) => {
      return [
        ...prev.slice(0, indexToUpdate),
        ...prev.slice(indexToUpdate + 1),
      ];
    });
    setTimeout(() => {
      validateForm();
    }, 100);
  };

  const handleColumnChange = (index: number, value: any) => {
    const newSelectedColumns = [...selectedColumns];
    newSelectedColumns[index] = columns.find((opt) => opt?.id === value);
    setSelectedColumns(newSelectedColumns);
    // also reset the operator
    setSelectedOperators((prev) => {
      return [...prev.slice(0, index), null, ...prev.slice(index + 1)];
    });
    // also reset the values
    setSelectedValues((prev) => {
      return [...prev.slice(0, index), null, ...prev.slice(index + 1)];
    });
  };

  const [reportColumnFilterDropdownValues] =
    useLazyReportColumnFilterDropdownValuesQuery();

  const handleOperatorChange = async (index: number, value: any) => {
    console.log("value operator", value);
    // try {
    //   const { data: valueList } = await reportColumnFilterDropdownValues({
    //     fields: selectedColumns[index]?.id,
    //     report_id: reportId,
    //   });
    //   const newvalueOptions = [...valueOptions];
    //   newvalueOptions[index] = valueList?.map((option) => ({value: Object.values(option)[0], label: Object.values(option)[0]}));
    //   setValueOptions(newvalueOptions);
    // } catch (e) {
    //   console.log("error", e);
    // }
    const newSelectedOperator = [...selectedOperators];
    newSelectedOperator[index] = value;
    setSelectedOperators(newSelectedOperator);
  };

  const handleValueSelect = (index: number, values: any) => {
    setSelectedValues((prev) => {
      const indexToUpdate = index; // Replace with the desired index
      return [
        ...prev.slice(0, indexToUpdate),
        values[2].join(","),
        ...prev.slice(indexToUpdate + 1),
      ];
    });
  };

  return (
    <FTModal
      visible={modalsState.showAdvanceFilterPopup}
      containerStyle="w-[640px]"
      dismissible={true}
      heading={t("heading")}
      onHide={hideModal}
      position="center"
    >
      {APP_CONFIG.DEBUG.DISPLAY_VERBOSE && (
        <pre className="text-[10px]">
          rows: {JSON.stringify(rows, null, 2)}
          <br />
          selectedColumns (truncated):{" "}
          {JSON.stringify(
            selectedColumns.map((item) => item?.all_field_id || null),
            null,
            2
          )}
          <br />
          selectedOperators: {JSON.stringify(selectedOperators, null, 2)}
          <br />
          selectedValues: {JSON.stringify(selectedValues, null, 2)}
        </pre>
      )}
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2 ">
            {/* Header */}
            <div className="relative flex gap-2 justify-around ps-8 pe-12">
              {FILTER_OPTIONS.map((option, index) => (
                <div
                  className="flex-1 text-left font-normal text-sm text-heading-gray888"
                  key={`filter-option-${index}`}
                >
                  {t(option)}
                </div>
              ))}
            </div>

            {/* Condition Rows */}
            {rows.map((option, index) => (
              <div
                className="relative w-full items-center flex gap-2 bg-gray-100 rounded-md pb-2 pt-1 ps-8 pe-12"
                key={`condition-row-${index}`}
              >
                <ErrorBoundaryForSection>
                  {/* Index */}
                  <div className="absolute w-8 top-1/2 -translate-y-1/2 left-0 text-center font-medium text-sm">
                    {index + 1}
                  </div>

                  {/* Remove Button */}
                  <button
                    type="button"
                    className="group absolute right-2 top-1/2 -translate-y-1/2 flex justify-center items-center w-8 h-8 bg-field-error-dark/10 disabled:bg-gray-400/10 enabled:hover:bg-field-error-dark disabled:opacity-50 rounded-lg enabled:cursor-pointer"
                    disabled={rows.length === 1}
                    onClick={() => removeRow(index)}
                  >
                    <img
                      src={svgIcons.CloseIcon}
                      className="size-5 opacity-60 group-enabled:group-hover:opacity-100 group-enabled:group-hover:brightness-0 group-enabled:group-hover:invert"
                    />
                  </button>

                  {/* Dropdowns */}
                  {APP_CONFIG.DEBUG.DISPLAY_VERBOSE && (
                    <pre className="absolute z-10 text-xs text-gray-400 -translate-y-5">
                      {selectedColumns[index]?.header}
                    </pre>
                  )}
                  <AdminFormFieldDropdown
                    key={`column-${selectedColumns}`} // to re-render the dropdown on column change
                    label={""}
                    id={""}
                    name={"column"}
                    placeholder={"Select..."}
                    customWrapperClass="flex-1"
                    options={columnsOptions}
                    value={selectedColumns[index]?.id}
                    onChange={(e) => handleColumnChange(index, e?.value)}
                  />
                  <AdminFormFieldDropdown
                    key={`operator-${index}-${selectedColumns[index]?.id}`} // to re-render the dropdown on column change
                    label={""}
                    id={""}
                    name={"operator"}
                    placeholder={"Select..."}
                    customWrapperClass="flex-1"
                    options={
                      selectedColumns[index]?.field_output_type &&
                      // getFieldSpecificFilterOptions(
                      //   selectedColumns[index]?.field_output_type
                      // )
                      ["IN", "NOT_IN"]?.map((option) => {
                        return {
                          value:
                            REPORT_FILTER_OPERATOR_TYPES[
                              option as keyof typeof REPORT_FILTER_OPERATOR_TYPES
                            ],
                          label: tFilterOptions(option),
                        };
                      })
                    }
                    value={selectedOperators[index]}
                    onChange={(e) => handleOperatorChange(index, e?.value)}
                    disabled={!selectedColumns[index]}
                  />
                  <div
                    className={`relative flex-1${showColumnsPopup[index] ? " z-popup" : ""}`}
                  >
                    <button
                      type="button"
                      className={`w-full h-11 mt-1 bg-white disabled:bg-gray-100 text-sm border border-gray-200 rounded px-2 py-2${selectedValues[index]?.split(",").length || 0 > 0 ? "" : " text-gray-400"}`}
                      onClick={() => {
                        setShowColumnsPopup((prev) => {
                          const indexToUpdate = index; // Replace with the desired index
                          return [
                            ...prev.slice(0, indexToUpdate),
                            true,
                            ...prev.slice(indexToUpdate + 1),
                          ];
                        });
                      }}
                      disabled={
                        !selectedColumns[index] || !selectedOperators[index]
                      }
                    >
                      {
                        (selectedValues[index]?.split(",").length || 0) === 0
                          ? "Select values"
                          : "selected" // `${selectedValues[index]?.split(",").length || 0} selected`
                      }
                    </button>

                    {/* Popup */}
                    {showColumnsPopup[index] &&
                      (!!selectedColumns[index]?.field_output_type ? (
                        <PopupReportColumnFilter
                          wrapperClass="top-full right-0 absolute mt-1 flex flex-col gap-2 py-2 bg-white border border-border-gray rounded-lg shadow-lg w-64 z-popup"
                          column={selectedColumns[index]}
                          showSelectableValues={
                            !!selectedColumns[index]?.show_selectable_values
                          }
                          isAdditionalDropdown={false}
                          fieldId={`${selectedColumns[index]?.id}`}
                          identifier={selectedColumns[index]?.identifier}
                          isLast
                          // isLast={index >= columns.length - 2} // last two columns to show popup on right side
                          reportId={reportId}
                          // selected={
                          //   (reportFilters
                          //     ?.find(
                          //       (filter: any) =>
                          //         filter.filter_type === REPORT_FILTER_TYPES.COLUMN &&
                          //         filter.param === selectedColumns[index].identifier
                          //     )
                          //     ?.value.split(",") || []) as string[]
                          // }
                          selected={selectedValues[index]?.split(",") || []}
                          onApplyReportColumnFilter={(...values) => {
                            handleValueSelect(index, values);
                            setShowColumnsPopup(
                              new Array(rows.length).fill(false)
                            );
                          }}
                          showResetButton={false}
                        />
                      ) : (
                        <div className="top-0 p-6 right-0 absolute mt-12 flex flex-col gap-2 py-2 bg-white border border-border-gray rounded-lg shadow-lg w-64 z-popup">
                          No data
                        </div>
                      ))}
                  </div>
                  {/* Popup Overlay */}
                  {showColumnsPopup[index] && (
                    <div
                      className="fixed inset-0 bg-modal-overlay z-popup-overlay"
                      onClick={() =>
                        setShowColumnsPopup(new Array(rows.length).fill(false))
                      }
                    ></div>
                  )}
                </ErrorBoundaryForSection>
              </div>
            ))}
          </div>

          {/* Add Row Button */}
          <div className="flex justify-start">
            <button type="button" className="flex justify-left cursor-pointer">
              <img src={svgIcons.AddRowIcon} onClick={addRow} />
            </button>
          </div>

          {/* Example Tooltip */}
          <div className="relative flex justify-end">
            {showExample && (
              <div className="absolute bottom-0 right-0 bg-gray-300 text-gray-600 px-2 py-1 flex justify-end text-xs rounded-md">
                Filter Logic: (1 AND 2) OR (3 AND 4)
              </div>
            )}
            <button
              type="button"
              className="absolute mt-2 text-accent-blue-dark font-semibold text-xs underline cursor-pointer z-10"
              onClick={() => setShowExample(!showExample)}
            >
              View Example
            </button>
          </div>

          <AdminFormFieldInput
            customWrapperClass="mb-4"
            label={"Build filter"}
            bottomLabel='Conditions can be used "AND","()","OR"'
            type={"text"}
            id={"filterLogic"}
            name={"filterLogic"}
            basicInputClass="h-11 mt-1 w-full rounded-md text-sm shadow-sm"
            placeholder="Enter filter logic here"
            value={values.filterLogic}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.filterLogic as string}
            touched={touched.filterLogic as boolean}
            detailsFormField={true}
          />
          <AdminFormFieldSubmit
            variant="primary-like"
            label={
              rows.length < 2 ? "Atleast two conditions are required" : "Apply"
            }
            type="submit"
            customWrapperClass="mb-2"
            disabled={!isValid || rows.length < 2}
          />
          <AdminFormFieldSubmit
            variant="danger"
            label={"Cancel"}
            onClick={hideModal}
          />
        </div>
      </form>
    </FTModal>
  );
};
export default AdvanceFilterPopUp;
